<script setup>
import { ElCollapseItem, ElIcon, ElOption, ElSelect, ElPagination, ElButton, ElPopconfirm } from 'element-plus';
import { ArrowRightBold,EditPen, Delete, InfoFilled, Setting, CloseBold } from '@element-plus/icons-vue'
import { storeToRefs } from 'pinia';
import { useProductStore } from '../../stores/fpe'; 
import { onMounted, ref, computed, reactive, watch } from 'vue';
import { ClickOutside as vClickOutside } from 'element-plus';
import { PopoverInstance } from 'element-plus';


const store = useProductStore();
const { strings, product, data_sets,addSelectedVariation, isGenerating, generationMessage, panelWidth } = storeToRefs(store);
const attributes = product.value.attributes || [];
const pageSize = 10;
const currentPage = ref(1);
const perPage = ref(pageSize);
const showBulkPriceSection = ref(false);
// PHP sends empty default_attributes as [] (JS Array) instead of {} (Object)
// Array.isArray check converts it to an object so Vue reactivity works
if (Array.isArray(product.value.default_attributes) || !product.value.default_attributes) {
    product.value.default_attributes = {};
}
const selectedAttributes = reactive(product.value.default_attributes);

const handleDefaultAttributeChange = (key, value) => {
    selectedAttributes[key] = value;
    // Sync to the store so updateProduct() sends the correct data
    product.value.default_attributes = { ...selectedAttributes };
}

const value = ref('');
const addPriceDialogVisible = ref(false);
const selectedVariation = ref(null);
const logCount = computed(() => product.value.variations ? product.value.variations.length : 0);
const selectedVariationDetails = ref(null);
const visible = ref(false);
const showDefaultAttibuteForm = ref(false);
const popoverWidth = computed(() => parseInt(panelWidth.value) - 25);
const bulkPrice = ref('');
// const loading = ref(false);

const renderPriceHtml = (regular_price, sale_price = null) => {
    if(sale_price){
        return `<span class="highlight-price">${sale_price}</span> - <span class="price">${regular_price}</span>`;
    }else if(regular_price){
        return `<span class="highlight-price">${regular_price}</span>`;
    }else{
        return '<span class="no-price">No price</span>';
    }
}


const handleSizeChange = (newSize) => {
  perPage.value = newSize;
};
const handleCurrentChange = (newPage) => {
  currentPage.value = newPage;
};

const filteredVariations = computed(() => {
    if (!product.value.variations) return [];
    const start = (currentPage.value - 1) * perPage.value;
    return product.value.variations.slice(start, start + perPage.value);
});

const calcMissingPriceVariations = computed(() => {
    if (!product.value.variations) return [];
    return product.value.variations.filter(variation => !variation.regular_price);
});

// add async function to edit variation
const editVariation = async (variationId) => {
  selectedVariation.value = variationId;
  store.setSelectedVariation(variationId);
//   try {
//     const details = await store.getVariationDetails(variationId);
//     console.log('Variation details', details);
//     selectedVariationDetails.value = details;
//     visible.value = true;
//   } catch (error) {
//     console.log('Error fetching variation details', error);
//   } finally {
//     loading.value = false;
//   }
};


const closeVariationPanel = () => {
    visible.value = false;
    selectedVariation.value = null;
    selectedVariationDetails.value = null;
}

const filterAttributes = computed(() => {
    const newAttributes = [];
    attributes.forEach(attribute => {
        let processedOptions = [];
        if(Array.isArray(attribute.options)){
            processedOptions = attribute.options.map(option => {
                if (typeof option === 'object' && option !== null) {
                    return {
                        label: option.label,
                        value: option.slug !== undefined ? option.slug : (option.value !== undefined ? option.value : option.label)
                    };
                }
                return {
                    label: option,
                    value: option
                }
            });
        }
        newAttributes.push({
            name: attribute.name,
            label: attribute.label,
            options: processedOptions,
            variation: attribute.variation,
            id: attribute.id,
            key: convertStringToKey(attribute.name)
        });
        // if(attribute.is_taxonomy){
        //     newAttributes.push({
        //         name: attribute.name,
        //         label: attribute.label,
        //         options: Object.values(attribute.options),
        //         variation: attribute.variation,
        //         id: attribute.id,
        //         key: Object.keys(attribute.options)
        //     });
        // }else{
        //     newAttributes.push({
        //         name: attribute.name,
        //         label: attribute.label,
        //         options: attribute.options,
        //         variation: attribute.variation,
        //         id: attribute.id,
        //         key: convertStringToKey(attribute.name)
        //     });
        // }
       
    });
    return newAttributes;
});



const convertStringToKey = (str) => {
    return str.toLowerCase().replace(/\s+/g, '-');
}


const generateVariations = () => {
    const isConfirmed = confirm('Do you want to generate all variations? This will create a new variation for each and every possible combination of variation attributes (max 50 per run). If you have already created variations manually, those will not be deleted but new variations will be added for the remaining combinations.');
    if (isConfirmed) {
        store.generateVariations();
    }
}    

const deletVariation = (variationId) => {
    store.deleteVariation(variationId);
}

const buttonRef = ref(null)
const popoverRef = ref(null)

const onClickOutside = () => {
  if (popoverRef.value) {
    popoverRef.value.hide()
  }
}


const visible1= ref(false);

const addBulkPrice = async () => {
    const price = parseFloat(bulkPrice.value);
    if (isNaN(price) || price < 0) {
        store.notice = {
            isError: true,
            isSuccess: false,
            message: 'Please enter a valid price',
        };
        return;
    }
    await store.bulkUpdateVariationPrice(bulkPrice.value);
    bulkPrice.value = '';
    showBulkPriceSection.value = false;
};

</script>
<template>
     <el-collapse-item :title="strings.section_title_variations" class="fpe-section-variations" name="variations" :icon="ArrowRightBold">
        <div class="fpe-field-product-variations">
            <!-- {{ selectedAttributes }}
            <div class="fpe-field-wrapper" data-field="defaults">
                <div class="fpe-field-default">
                    <label>Default Form Value
                        <Info :tooltip_text="strings.label_variation_default_attribute" />
                    </label>
                    <el-icon class="fpe-defualt-attribute-toogle" :class="showDefaultAttibuteForm ? 'active' : ''" @click="showDefaultAttibuteForm = !showDefaultAttibuteForm" ><Setting /></el-icon>
                </div>
                            
                <div class="fpe-variations-defaults" v-if="showDefaultAttibuteForm">
                    <div class="fpe-default-form-attribut" v-for="( attribute, index) in filterAttributes" :key="attribute.id" :class="`fpe-default-form-attribut-${attribute.name}`">
                        <label class="fpe-default-form-attribute-name">{{ attribute.name }}
                        </label>
                        <el-select
                            :key="attribute.id"
                            :name="attribute.key"
                            class="fpe-default_attribute"
                            v-on:change="handleDefaultAttributeChange(attribute.key, $event)"
                            placeholder="Select"
                            v-model="selectedAttributes[attribute.key]"
                            v-if="attribute.variation"
                            >
                                <el-option
                                    v-for="option in attribute.options"
                                    :key="option.value"
                                    :label="option.label"
                                    :value="option.value"
                                />
                        </el-select>
                    </div>   
                </div>
            </div> -->
            <div class="fpe-field-wrapper" data-fields="defaults">
                <div class="fpe-field-default">
                    <label>Default Form Value
                        <Info :tooltip_text="strings.label_variation_default_attribute" />
                    </label>
                    <el-popover placement="bottom-end" 
                        :width="popoverWidth"  
                        :visible="visible1">
                        <template #reference>
                            <el-icon @click="visible1 = !visible1" class="fpe-defualt-attribute-toogle" :class="visible1 ? 'active' : ''" ><Setting /></el-icon>
                        </template>
                        <template #default>
                            <div class="fpe-popover-close">
                                <el-icon @click="visible1 = !visible1"><CloseBold /></el-icon>
                            </div>
                            <div class="fpe-variations-defaults">
                                
                                <div class="fpe-default-form-attribut" v-for="( attribute, index) in filterAttributes" :key="attribute.id" :class="`fpe-default-form-attribut-${attribute.name}`">
                                    <label class="fpe-default-form-attribute-name">{{ attribute.label }}
                                    </label>
                                    <el-select
                                        :key="attribute.id"
                                        :name="attribute.key"
                                        class="fpe-default_attribute"
                                        v-model="selectedAttributes[attribute.key]"
                                        placeholder="Select"
                                        v-if="attribute.variation"
                                        >   
                                        <el-option
                                            v-for="option in attribute.options"
                                            :key="option.value"
                                            :label="option.label"
                                            :value="option.value"
                                            />
                                    </el-select>
                                </div>   
                            </div>
                        </template> 
                    </el-popover>
                    
                </div>
            </div>
            <div class="fpe-field-wrapper" data-field="actiions">
                <div class="fpe-variations-actions">
                    <el-button type="primary" @click="generateVariations">{{ product.variations.length > 0 ? strings.button_generate_more_variations : strings.button_generate_variations }}</el-button>
                    <el-button type="primary" @click="store.openNewVariation()">{{ strings.button_add_variation_manually }}</el-button>
                </div>
            </div>
            <!-- <div class="fpe-field-wrapper" data-field="bulk-actions">
                <label>Bulk Actions</label>
                <div class="fpe-variations-bulk-actions">
                    <el-select>
                        <el-option label="Set Regular Price" value="set_regular_price" />
                        <el-option label="Set Sale Price" value="set_sale_price" />
                        <el-option label="Remove Sale Price" value="remove_sale_price" />
                    </el-select>
                </div>
            </div> -->
           <div class="fpe-field-wrapper" data-field="bulk-price" v-if="calcMissingPriceVariations.length > 0"> 
            <div class="fpe-variation-price-missing-notice">
                <span class="fpe-price-missing-notice">{{ calcMissingPriceVariations.length > 0 ? `${calcMissingPriceVariations.length} variations do not have prices. Variations (and their attributes) that do not have prices will not be shown in your store.` : '' 
                }}</span>
                 <el-button @click="showBulkPriceSection = !showBulkPriceSection">Add Price</el-button>
                <div class="fpe-bulk-price" v-if="showBulkPriceSection">
                    <span>Add price to all variations that don't have a price</span>
                    <el-input
                        v-model="bulkPrice"
                        placeholder="Enter Price"
                        type="number"
                        min="0"
                        step="1"
                    />
                    <div class="fpe-bulk-price-actions">
                            <el-button class="fpe-bulk-price-cancel" @click="showBulkPriceSection = false">Cancel</el-button>
                            <el-button type="primary" class="fpe-bulk-price-add" @click="addBulkPrice()">Add Price</el-button>
                    </div>
                </div> 
           </div>
           </div>  
            <div class="fpe-field-wrapper" data-field="pagination">
                    <div class="fpe-table-pagination">
                        <el-pagination
                            layout="total, prev, pager, next" 
                            :total="logCount"
                            :current-page="currentPage"
                            :page-size="perPage"
                            @current-change="handleCurrentChange"
                            background
                            size="small"
                            class="mt-4"
                            pager-count="4"
                        />
                    </div>
            </div>   
            <div class="fpe-field-wrapper" data-field="list">
                <div class="fpe-variation-list-overlay" v-if="isGenerating">
                    <div class="fpe-loader"></div>
                    <span class="">{{ generationMessage }}</span>
                </div>  
                <div class="fpe-variation-list">
                    <div v-for="variation in filteredVariations" :key="variation.id">
                        <div class="fpe-variation-item" :class="{ 'fpe-variation-active': selectedVariation === variation.id }">
                                <div class="fpe-varition-item-image">
                                    <img :src="variation.image_src" alt="Variation Image" v-if="variation?.image_src" />
                                </div>
                                <div class="fpe-varition-item-content">
                                
                                    <h5 class="fpe-varition-title">
                                        {{ 
                                            Object.values(variation.attributes).join(" . ") 
                                        }}
                                    </h5>
                                    <div class="fpe-varition-details">
                                        <span class="fpe-variation-sku">
                                            {{ variation.sku ? `SKU: ${variation.sku}` : '' }}
                                        </span> | 
                                        <span class="fpe-variation-price" v-html="renderPriceHtml(variation.regular_price, variation?.sale_price)">
                                        </span> | 
                                        <span class="fpe-variation-stock" :class="variation.stock_status">
                                            <span v-if="variation.stock_status === 'instock'">{{ strings.label_instock }}</span>
                                            <span v-if="variation.stock_status === 'outofstock'">{{ strings.label_outofstock }}</span>
                                            <span v-if="variation.stock_status === 'onbackorder'">{{ strings.label_onbackorder }}</span>
                                        </span>
                                    </div>
                                
                                
                                </div>
                                <div class="fpe-varition-item-action">
                                    <el-icon class="edit" @click="editVariation(variation.id)"><EditPen /></el-icon>
                                     <el-popconfirm
                                        width="250"
                                        :icon="InfoFilled"
                                        icon-color="#626AEF"
                                        title="Are you sure to delete this?"
                                        popper-class="fpe-delete-variation-popover"
                                    >
                                        
                                        <template #reference>
                                            <el-button type="danger" :icon="Delete" circle/>
                                        </template>
                                        <template #actions="{ confirm, cancel }">
                                            <div class="fpe-popconfirm-actions">
                                            <el-button @click="cancel" class="fpe-delete-variation-cancel">No!</el-button>
                                            <el-button
                                                size="small"
                                                @click="deletVariation(variation.id)"
                                                class="fpe-delete-variation-confirm"
                                            >
                                                Yes
                                            </el-button>
                                        </div>  
                                        </template>
                                    </el-popconfirm>
                                    <!-- <el-popconfirm
                                        confirm-button-text="Yes"
                                        cancel-button-text="No"
                                        :icon="InfoFilled"
                                        icon-color="#626AEF"
                                        title="Are you sure to delete this?"
                                        @confirm="deletVariation(variation.id)"
                                        width="250"
                                    >
                                     <template #reference>
                                        <el-button type="danger" :icon="Delete" circle/>
                                    </template>
                                     </el-popconfirm> -->
                                </div>
                        </div>
                        
                    </div>
                </div>   
            </div>   
            
        </div>
        
        </el-collapse-item> </template>